import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { ForgePioHelpjuiceIcon, ForgePioHelpjuiceSearchResultIcon } from './icon';

export const forgePioHelpjuiceConfig: ThirdPartyConfig = {
	displayName: 'Helpjuice by Pio',
	id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	resourceType: ProductResourceTypes3P.ForgePioHelpjuiceProd,
	icon: get3PLogo(ForgePioHelpjuiceIcon, 'ForgePioHelpjuice', 'medium'),
	searchResultIcon: get3PLogo(ForgePioHelpjuiceSearchResultIcon, 'ForgePioHelpjuice', 'large'),
	integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
